/** @format */

import { Navigate, Outlet } from "react-router-dom";
import { useFeatureFlag } from "../hooks/useFeatureFlag";

interface FeatureFlagRouteProps {
	flagKey: string;
	/** Where to send the user when the flag is off. */
	redirectTo: string;
}

/**
 * Layout route that renders its child routes only while a feature flag is on.
 * With the flag off, a typed or bookmarked URL redirects instead of rendering the page.
 */
export const FeatureFlagRoute = ({ flagKey, redirectTo }: FeatureFlagRouteProps) => {
	const isEnabled = useFeatureFlag(flagKey);
	return isEnabled ? <Outlet /> : <Navigate to={redirectTo} replace />;
};
